import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import React, { useState } from 'react';
import SharedSpecialtyLogic from './shared';
import { specialtiesPropTypes } from './shared';

function getPropertyType(propertyTypes) {
  return propertyTypes;
}

function initialSpecialtiesSelected(specialtiesOptions, userSpecialties) {
  const selectedBrokerSpecialtyId = userSpecialties.map(s => s.brokerSpecialtyId);
  return specialtiesOptions.filter(o => selectedBrokerSpecialtyId.includes(o.value));
}

export default function UngroupedSpecialties({
  allBrokerSpecialties,
  pcUser,
  showSpecialtiesOnBrokerPlugin,
  userSpecialties
}) {
  const specialtiesOptions = allBrokerSpecialties.map(a => ({ value: a.id, label: a.title }));
  const [selectedSpecialties, setSelectedSpecialties] = useState(
    () => initialSpecialtiesSelected(specialtiesOptions, userSpecialties)
  );

  const selectedOptionsById = selectedSpecialties.reduce((accumulator, currentValue) => {
    const propertyType = allBrokerSpecialties.find(s => s.id === currentValue.value).propertyType;
    accumulator[currentValue.value] = { values: [propertyType] };
    return accumulator;
  }, {});

  return (
    <React.Fragment>
      <Row className="form-group">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={specialtiesOptions}
            value={selectedSpecialties}
            onChange={setSelectedSpecialties}
          />
        </Col>
      </Row>

      <SharedSpecialtyLogic
        getPropertyType={getPropertyType}
        pcUser={pcUser}
        selectedOptionsById={selectedOptionsById}
        showSpecialtiesOnBrokerPlugin={showSpecialtiesOnBrokerPlugin}
        userSpecialties={userSpecialties}
      />
    </React.Fragment>
  );
}

UngroupedSpecialties.propTypes = specialtiesPropTypes;
